import { toDate as S } from "./toDate.js";
import { getDefaultOptions as m } from "./_lib/defaultOptions.js";
function y(w, t) {
  var f, c, n, O, l, k, u, d;
  const a = m(), r = (d = (u = (O = (n = t == null ? void 0 : t.weekStartsOn) != null ? n : (c = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : c.weekStartsOn) != null ? O : a.weekStartsOn) != null ? u : (k = (l = a.locale) == null ? void 0 : l.options) == null ? void 0 : k.weekStartsOn) != null ? d : 0, e = S(w), s = e.getDay(), D = (s < r ? 7 : 0) + s - r;
  return e.setDate(e.getDate() - D), e.setHours(0, 0, 0, 0), e;
}
export {
  y as default,
  y as startOfWeek
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/startOfWeek.js
// module id = 144
// module chunks = 67